var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"budget-usage-bar",class:{ 'budget-usage-bar--compact': _vm.compact }},[_c('div',{staticClass:"budget-usage-bar__track"},[_c('div',{staticClass:"budget-usage-bar__fill",class:`budget-usage-bar__fill--${_setup.state}`,style:({ width: `${_setup.percent}%` })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }